/**
 * Consistent blog date display across Insights, investor portal, etc.
 * Uses India locale with a clear, unambiguous format.
 */
export function formatBlogDate(
  date: { toDate?: () => Date } | null | undefined
): string {
  if (!date?.toDate) return '—';
  const d = date.toDate();
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}
